export default {
  namespaced: true,
  state: {
    categories: [],
    filtersForm: {
      nameContains: "",
      sectionId: "",
      audience: "",
    },
  },

  getters: {
    getQueryVariables(state) {
      return () => {
        const { nameContains, sectionId, audience } = state.filtersForm;
        const variables = {};

        if (nameContains) variables.nameContains = nameContains;
        if (sectionId) variables.sectionId = sectionId;
        if (audience) variables.audience = audience;

        return variables;
      };
    },
  },

  mutations: {
    SET_CATEGORIES(state, category) {
      state.categories = category;
    },

    SET_CATEGORY(state, form) {
      state.filtersForm.sectionId = form;
    },

    SET_SEARCH(state, search) {
      state.filtersForm.nameContains = search;
    },

    SET_AUDIENCE(state, audience) {
      state.filtersForm.audience = audience;
    },

    SET_FILTERS_FORM(state, form) {
      state.filtersForm = form;
    },
  },
};
